import { appColors } from '@backrs_ui/common-ui';

import {
  CareerUserResponseAnswer,
  CareerUserResponseSet,
  CareerQuestion,
} from '@backrs_ui/grow-ui/src/models/models';

import { Box, TextField, Typography, SxProps, Theme } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

const CUSTOM_ANSWER_MAX_LENGTH = 200;

type CustomAnswerProps = Readonly<{
  responsesForQuestion?: CareerUserResponseAnswer;
  userResponseSet: CareerUserResponseSet;
  question: CareerQuestion;
  addUserQuestionResponse: (response: CareerUserResponseAnswer) => void;
}>;

export const CustomAnswer = ({
  responsesForQuestion,
  userResponseSet,
  question,
  addUserQuestionResponse,
}: CustomAnswerProps) => {
  function handleAddingAnswerToResponse(response: string) {
    if (response.length > CUSTOM_ANSWER_MAX_LENGTH) {
      return;
    }

    if (responsesForQuestion) {
      const updatedResponse = {
        ...responsesForQuestion,
        career_question_option_custom_text: response,
      };

      addUserQuestionResponse(updatedResponse);

      return;
    }

    const newResponse: CareerUserResponseAnswer = {
      id: uuidv4(),
      career_user_response_set_id: userResponseSet.id,
      career_question_id: question.id,
      career_question_option_ids: [],
      career_question_option_custom_text: response,
    };

    addUserQuestionResponse(newResponse);
  }

  return (
    <Box sx={questionContainerStyle}>
      <TextField
        sx={textFieldStyle}
        multiline
        value={responsesForQuestion?.career_question_option_custom_text ?? ''}
        maxRows={5}
        minRows={5}
        onChange={(event) => handleAddingAnswerToResponse(event.target.value)}
      />
      <Typography variant="caption" sx={textCountStyle}>
        {responsesForQuestion?.career_question_option_custom_text?.length ?? 0}/
        {CUSTOM_ANSWER_MAX_LENGTH}
      </Typography>
    </Box>
  );
};

const questionContainerStyle: SxProps<Theme> = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
} as const;

const textCountStyle: SxProps<Theme> = {
  color: appColors.neutral.black,
  alignSelf: 'flex-end',
  fontWeight: 500,
} as const;

const textFieldStyle: SxProps<Theme> = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: appColors.neutral.black,
      borderRadius: 2,
    },
    '&:hover fieldset': {
      borderColor: appColors.neutral.black,
      borderRadius: 2,
    },
    '&.Mui-focused fieldset': {
      borderColor: appColors.color.blue1,
      borderRadius: 2,
    },
  },
} as const;
